<div class="tcf">
  <header class="tcf-header">
    <h2>Change password</h2>
    <p class="tcf-subtitle">Enter your current password before choosing a new one.</p>
  </header>

  <form class="tcf-body" [formGroup]="form" (ngSubmit)="submit()">
    <label class="field">
      <span class="field-label">Current password <em>*</em></span>
      <input type="password" formControlName="currentPassword" autocomplete="current-password" />
      <span class="field-error" *ngIf="form.get('currentPassword')?.touched && form.get('currentPassword')?.hasError('required')">Required</span>
    </label>

    <label class="field">
      <span class="field-label">New password <em>*</em></span>
      <input type="password" formControlName="newPassword" autocomplete="new-password" />
      <span class="field-error" *ngIf="form.get('newPassword')?.touched && form.get('newPassword')?.hasError('required')">Required</span>
      <span class="field-error" *ngIf="form.get('newPassword')?.hasError('minlength')">At least 8 characters</span>
    </label>

    <label class="field">
      <span class="field-label">Confirm new password <em>*</em></span>
      <input type="password" formControlName="confirmPassword" autocomplete="new-password" />
      <span class="field-error" *ngIf="form.get('confirmPassword')?.touched && form.get('confirmPassword')?.hasError('required')">Required</span>
      <span class="field-error" *ngIf="form.hasError('mismatch') && form.get('confirmPassword')?.touched">Passwords don't match</span>
    </label>

    <p class="tcf-error" *ngIf="error" role="alert">{{ error }}</p>
  </form>

  <footer class="tcf-actions">
    <button type="button" class="br-btn br-btn--ghost" (click)="cancel()">Cancel</button>
    <button type="button" class="br-btn br-btn--primary" [disabled]="form.invalid || submitting" (click)="submit()">
      {{ submitting ? 'Saving…' : 'Change password' }}
    </button>
  </footer>
</div>
